import { GET_DRIVER_QUEUE} from './actionTypes';


import { receiveError } from './notificationAction';
import { baseUrl } from '../../api/baseUrl';
import DriverQueue from '../../models/DriverQueue';

function getDriverQueue(queue: Array<DriverQueue>) {
  return {
      type: GET_DRIVER_QUEUE,
      data: queue
  }
}

function receiveDriverQueue() {

  return (dispatch: any) => {

    const queue = new EventSource(baseUrl + `queue`, {
        withCredentials: true
    });



    queue.onmessage = (event) => {

      const parsedData = JSON.parse(event.data);
      if(parsedData.queue) {
        dispatch(getDriverQueue(parsedData));
      }

    }

    queue.onerror = (error: any) => {

      if(error.type === 'error') {

        dispatch(receiveError(error));

      }

   }
  };
}

export {
    receiveDriverQueue
}